<div class="timeline__title" [class.timeline__title--active]="IsActive">
  <ng-content></ng-content>
</div>
